module.exports = __webpack_public_path__ + "loader.svg?2c13d8c1c75c0a9950afb3513bdd2ffe";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loader.svg
// module id = 205
// module chunks = 309